module.exports = __webpack_public_path__ + "media/locales/_ru-d3e8edf0.png";